import { useState, useEffect, useContext } from 'react'
import { InsightText, Table, Switch, Gauge, Button } from "freespace-react-components";
import HealthOverviewContext from '../../context/HealthOverviewContext';
import { useNavigate } from 'react-router-dom';
import { SpaceIOService } from 'auth-utils'

const columns = [
    <p key="account-id" className="text-xs text-primaryText">Account Id</p>,
    <p key="logo" className="text-xs text-primaryText ">Logo</p>,
    <p key="account-name" className="text-xs text-primaryText ">Account Name</p>,
    <p key="Overall" className="text-xs text-primaryText ">Overall</p>,
    <p key="one" className="text-xs text-primaryText ">ONE (%)</p>,
    <p key="tim" className="text-xs text-primaryText ">TIM (%)</p>,
    <p key="flo" className="text-xs text-primaryText ">FLO (%)</p>,
    <p key="bat-tim" className="text-xs text-primaryText ">BAT-TIM (%)</p>,
    <p key="tim-plus" className="text-xs text-primaryText ">TIM+ (%)</p>,
    <p key="pam" className="text-xs text-primaryText ">PAM (%)</p>,
];


const stickyColumms = [0, 1];

const HealthOverview = () => {
    const navigate = useNavigate();

    const { accountsInfo } = useContext<any>(HealthOverviewContext)

    const accountInfoData = accountsInfo.map((account) => ({
        Logo: account.logoUrl,
        "Account Id": account.id,
        "Account Name": account.name,
        liveStatus: account.showInMenu,
        ...account.accountLevelDeviceHealth
    }));

    // console.log(accountsInfo);
    // console.log(accountInfoData);



    const { quickInfoData } = useContext<any>(HealthOverviewContext)

    const [selectedColumns, setSelectedColumns] = useState(columns);
    // const [selectedCol, setSelectedCol] = useState<string[]>([]);


    const [selectedAccount, setSelectedAccount] = useState<string[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rows, setRows] = useState([]);
    const [count, setCount] = useState(1); // Initial count state
    const [isChecked, setIsChecked] = useState(false);
    const [averagePercentages, setAveragePercentages] = useState<object>({})

    const accountNameDropDownList = accountsInfo.map((item: { name: string; }) => (item.name));

    const [selectedAccountStatus, setSelectedAccountStatus] = useState<string[]>([]);
    const [accountDropdown, setAccountDropdown] = useState()

    const [showQuickInfo, setShowQuickInfo] = useState(false);

    useEffect(() => {
        setAveragePercentages(quickInfoData)
        console.log("quickInfoData", quickInfoData)
    }, [averagePercentages])

    useEffect(() => {
        if (accountsInfo.length > 0) {
            // Update the state with the new average percentages
            // setAveragePercentages(newAveragePercentages);

            const LiveAccountsInfo = accountsInfo.filter(liveaccounts => {
                if (selectedAccountStatus.includes('Active') && selectedAccountStatus.includes('Archieve')) {
                    // console.log("active & archieve data")
                    return true

                }
                else if (selectedAccountStatus.includes('Archieve')) {
                    // console.log("archeive data")
                    return liveaccounts.showInMenu === false;
                    // console.log("archieve with active values")
                }
                else {
                    return liveaccounts.showInMenu === true;
                }
            })

            setAccountDropdown(LiveAccountsInfo.map((item: { name: string; }) => (item.name)))

            const updatedRows = LiveAccountsInfo.map((item:
                {
                    id: number;
                    logoUrl: string;
                    name: string;
                    accountLevelDeviceHealth: object
                }, index: number) => [
                    item.id,
                    <img className="w-auto h-4" src={item.logoUrl} alt={item.name} onError={e => { e.currentTarget.src = item.name }}></img>,
                    <p className='cursor-pointer' onClick={() => handleClick(item.id)}>{item.name}</p>,
                    typeof (item.accountLevelDeviceHealth?.['Overall']) === 'number' ? <p>{item.accountLevelDeviceHealth?.['Overall']}</p> : <p>-</p>,
                    // renderCellContent(item.accountLevelDeviceHealth?.['ONE'], isChecked),
                    // renderCellContent(item.accountLevelDeviceHealth?.['TIM'], isChecked),
                    // renderCellContent(item.accountLevelDeviceHealth?.['FLO'], isChecked),
                    // renderCellContent(item.accountLevelDeviceHealth?.['BAT-TIM'], isChecked),
                    // renderCellContent(item.accountLevelDeviceHealth?.['TIM+'], isChecked),
                    // renderCellContent(item.accountLevelDeviceHealth?.['PAM'], isChecked),

                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['ONE'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['ONE']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['ONE'] === 'number' ? item.accountLevelDeviceHealth?.['ONE'] : <p>-</p>),
                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['TIM'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['TIM']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['TIM'] === 'number' ? <p>{item.accountLevelDeviceHealth?.['TIM']}</p> : <p>-</p>),
                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['FLO'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['FLO']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['FLO'] === 'number' ? <p>{item.accountLevelDeviceHealth?.['FLO']}</p> : <p>-</p>),
                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['BAT-TIM'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['BAT-TIM']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['BAT-TIM'] === 'number' ? <p>{item.accountLevelDeviceHealth?.['BAT-TIM']}</p> : <p>-</p>),
                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['TIM+'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['TIM+']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['TIM+'] === 'number' ? <p>{item.accountLevelDeviceHealth?.['TIM+']}</p> : <p>-</p>),
                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['PAM'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['PAM']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['PAM'] === 'number' ? <p>{item.accountLevelDeviceHealth?.['PAM']}</p> : <p>-</p>),
                    isChecked
                        ? (typeof item.accountLevelDeviceHealth?.['MS'] === 'number' ? <p style={{ color: '#FF5E5E' }}>{parseFloat((100 - item.accountLevelDeviceHealth?.['MS']).toFixed(2))}</p> : <p>-</p>)
                        : (typeof item.accountLevelDeviceHealth?.['MS'] === 'number' ? <p>{item.accountLevelDeviceHealth?.['MS']}</p> : <p>-</p>),
                ]
            );

            //updated rows
            const updatedRowsData = LiveAccountsInfo.map(
                (
                    item: {
                        id: number;
                        logoUrl: string;
                        name: string;
                        accountLevelDeviceHealth: object;
                    },
                    index: number
                ) => [{
                    "Account Id": <p>{item.id}</p>,
                    "Logo": <img className="w-auto h-4" src={item.logoUrl} alt={item.name} onError={(e) => { e.currentTarget.src = item.name; }}></img>,
                    "Account Name": <p className="cursor-pointer text-left" style={{ textAlign: 'left' }} onClick={() => handleClick(item.id)}>{item.name}</p>,
                    "Overall": typeof item.accountLevelDeviceHealth?.["Overall"] === "number" ? (<p>{item.accountLevelDeviceHealth?.["Overall"]}</p>) : (<p>-</p>),
                    "ONE (%)": isChecked ? (typeof item.accountLevelDeviceHealth?.["ONE"] === "number" ? (
                        <p style={{ color: "#FF5E5E" }}>
                            {parseFloat(
                                (100 - item.accountLevelDeviceHealth?.["ONE"]).toFixed(2)
                            )}
                        </p>
                    ) : (
                        <p>-</p>
                    )
                    ) : typeof item.accountLevelDeviceHealth?.["ONE"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["ONE"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "TIM (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["TIM"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["TIM"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["TIM"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["TIM"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "TIM+ (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["TIM+"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["TIM+"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["TIM+"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["TIM+"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "BAT-TIM (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["BAT-TIM"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["BAT-TIM"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["BAT-TIM"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["BAT-TIM"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "PAM (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["PAM"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["PAM"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["PAM"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["PAM"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "PAL (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["PAL"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["PAL"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["PAL"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["PAL"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "MS (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["MS"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["MS"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["MS"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["MS"]}</p>
                    ) : (
                        <p>-</p>
                    ),
                    "FLO (%)": isChecked ? (
                        typeof item.accountLevelDeviceHealth?.["FLO"] === "number" ? (
                            <p style={{ color: "#FF5E5E" }}>
                                {parseFloat(
                                    (100 - item.accountLevelDeviceHealth?.["FLO"]).toFixed(2)
                                )}
                            </p>
                        ) : (
                            <p>-</p>
                        )
                    ) : typeof item.accountLevelDeviceHealth?.["FLO"] === "number" ? (
                        <p>{item.accountLevelDeviceHealth?.["FLO"]}</p>
                    ) : (
                        <p>-</p>
                    )
                }
                    ]
            );

            let showColumnList = [];
            selectedColumns.filter((column) => {
                showColumnList.push(column.props.children)
                // return column.props.children
            });


            const filteredItems = updatedRowsData.map(itemArray => {
                return itemArray.map(item => {
                    return showColumnList.reduce((newItem, key) => {
                        if (item.hasOwnProperty(key)) {
                            newItem[key] = item[key];
                        }
                        return newItem;
                    }, {});
                });
            });


            const updatedRowsValues = filteredItems.map(subArray =>
                subArray.map(obj =>
                    Object.values(obj)
                )
            );


            const flatData = updatedRowsValues.flat()

            let filteredRows = flatData;

            if (selectedAccount.length > 0) {
                filteredRows = updatedRows.filter((row: any) =>
                    selectedAccount.includes(row[2].props.children)
                );
            }


            // Update the rows directly based on the current page
            // Calculate the total number of pages

            const startIndex = (currentPage - 1) * 20;
            const endIndex = Math.min(startIndex + 20, filteredRows.length);

            setRows(filteredRows.slice(startIndex, endIndex).map((row: any) => ({ ...row })));
            setCount(Math.ceil(filteredRows.length / 20));
        }
    }, [currentPage, selectedAccount, isChecked, selectedAccountStatus, selectedColumns]);



    const handleClick = async (accountId: number) => {
        await SpaceIOService.switchAccount(accountId);
        navigate('/account-health-overview')
    }

    // Callback function to update selected items
    const handleSelectedItemsChangeAccounts = (newSelectedItems: Array<string>) => {
        setSelectedAccount(newSelectedItems);
    };

    const handleSelectedItemsChangeAccountStatus = (newSelectedItems: Array<string>) => {
        setSelectedAccountStatus(newSelectedItems);
    };

    const handlePageChange = (page: number) => {
        // Update state or perform any other actions based on the page change
        setCurrentPage(page);
    };

    const handleSwitchStatus = (isChecked: boolean) => {
        setIsChecked(isChecked);
    }

    // Callback function to update selected items
    const handleSelectedItemsChange = (newSelectedItems: Array<string>) => {
        // console.log("newselected item", newSelectedItems)
        if (newSelectedItems.length === 0) {
            setSelectedColumns(columns); // Display all columns when no items are selected
        } else {
            // Filter columns based on the selected items
            const filteredColumns = columns.filter((column) => {
                return newSelectedItems.includes(column.props.children)
            });
            // Filter columns by indexes specified in stickyColumns and concatenate with filteredColumns
            const stickyFilteredColumns = stickyColumms.map((index) => columns[index]);
            setSelectedColumns([...stickyFilteredColumns, ...filteredColumns]);
        }
    };


    const dropdownList = columns
        .filter((_, index) => !stickyColumms.includes(index)) // Filter out columns in stickyColumms
        .map((column) => {
            // Extract the text content from each <p> element
            const textContent = column.props.children;
            return textContent;
        });

    // console.log(dropdownList);


    // const filters = [
    //     <div className={tw`flex flex-row item-center gap-4`} key='dropdown' >
    //         <DropDownTable
    //             defultSelectAllFlag={false}
    //             dropdownList={dropdownList}
    //             dropDownName='Show Columns'
    //             dropDownListName=''
    //             onSelectedItemsChange={handleSelectedItemsChange} // Pass the callback function as a prop
    //         />
    //         <DropDownTable
    //             defultSelectAllFlag={false}
    //             dropdownList={['Active', 'Archieve']}
    //             dropDownName='Status'
    //             dropDownListName=''
    //             onSelectedItemsChange={handleSelectedItemsChangeAccountStatus}// Pass the callback function as a prop
    //         />
    //         <DropDownTable
    //             defultSelectAllFlag={false}
    //             dropdownList={accountDropdown}
    //             dropDownName='Accounts'
    //             dropDownListName=''
    //             onSelectedItemsChange={handleSelectedItemsChangeAccounts} // Pass the callback function as a prop
    //         />
    //     </div >,
    //     <Switch
    //         key={'In Risk View'}
    //         leftLabel="In Risk View"
    //         onChange={handleSwitchStatus}
    //     />
    // ];

    // const handleSelectedCell = (cell) => {
    //     console.log('Selected Cell:', cell);
    //     console.log('Selected Cell:', cell.value);
    //     console.log('Selected Cell:', cell.cellIndex);
    //     if (cell.cellIndex < 3) {
    //         // page 2
    //         handleClick(cell.rowData.accountId)
    //     } else {
    //         // page 3
    //         console.log('do not do any thing ');

    //     }
    // };


    const handleSelectedCell = async (cell) => {
        // console.log(cell);
        if (cell.cellIndex < 3) {
            // console.log("cell", cell)
            handleClick(cell.rowData['Account Id'])
        } else {
            if (cell.cellIndex > 3) {
                await SpaceIOService.switchAccount(cell.rowData['Account Id']);
                navigate('/device-health', {
                    state: {
                        ProductType: cell.field
                    }
                })
            }
        }
    };

    const tagConditions = [
        {
            key: 'Overall',
            condition: (value) => value > 80 ? 'success' : value > 60 ? 'warning' : 'danger'
        }
    ];

    return (
        <div className=' flex flex-row bg-backgroundColor' >
            <div style={{ width: `${showQuickInfo ? '80%' : '100%'}` }}>
                <div className=' flex bg-green-50 h-18 drop-shadow-md overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style]:none [scrollbar-width]:none'>
                    <InsightText
                        primaryText={"91 King William Street-7th Floor"}
                        secondaryText={
                            <div className='flex flex-col text-xs'>
                                <p>Australia-Adelaide</p>
                            </div>
                        }
                        contentInput={
                            <p className=" text-xs">25%</p>
                        }
                    />
                    <InsightText
                        primaryText={"91 King William Street-7th Floor"}
                        secondaryText={
                            <div className='flex flex-col text-xs'>
                                <p>Australia-Adelaide</p>
                            </div>
                        }
                        contentInput={
                            <p className=" text-xs">25%</p>
                        }
                    />
                    <InsightText
                        primaryText={"91 King William Street-7th Floor"}
                        secondaryText={
                            <div className='flex flex-col text-xs'>
                                <p>Australia-Adelaide</p>
                            </div>
                        }
                        contentInput={
                            <p className=" text-xs">25%</p>
                        }
                    />
                    <InsightText
                        primaryText={"91 King William Street-7th Floor"}
                        secondaryText={
                            <div className='flex flex-col text-xs'>
                                <p>Australia-Adelaide</p>
                            </div>
                        }
                        contentInput={
                            <p className=" text-xs">25%</p>
                        }
                    />
                </div>
                <Table
                    data={accountInfoData}
                    minWidth={'80rem'}
                    commonColumsName={['Logo', 'Account Name', 'Account Id', 'Overall']}
                    columnsName={['ONE', 'TIM', 'BAT-TIM', 'FLO', 'TIM+', 'BAT-TIM+', 'PAM', 'PAL', 'MS']}
                    imageCol={['Logo']}
                    frozenCol={['Logo']}
                    scrollHeight={'460px'}
                    tagCol={['Overall', 'MS']}
                    tagConditions={tagConditions}
                    multiSelectFilter={[
                        {
                            key: 'Account Name',
                            placeholder: 'Account Name',
                            searchFilter: true,
                            option: accountInfoData,
                            lableKey: ''
                        }
                    ]}
                    dropDownFilter={[{
                        key: 'liveStatus',
                        lableKey: 'lable',
                        placeholder: 'Live Status',
                        searchFilter: false,
                        option: [
                            { liveStatus: true, lable: 'Active' },
                            { liveStatus: false, lable: 'Inactive' },
                        ],
                    }]}
                    setSelectedCell={handleSelectedCell}
                    extraTableHeaderElement={[
                        // <div key="in-risk-view" className='flex justify-center items-center gap-2'>
                        //     <p className='text-xs lg:text-sm font-normal'>In-Risk View</p>
                        //     <Switch
                        //         onChange={(isChecked) => {
                        //             // console.log(isChecked);
                        //         }} />
                        // </div>,
                        <div key="clear-filter" className='flex justify-center items-center gap-2'>
                            <Button
                                // className='py-1.5 px-2 text-xs lg:text-sm h-6 font-sans'
                                // type="button"
                                severity='success'
                                size="small"
                                icon='pi pi-sparkles'
                                outlined={true}
                                onClick={() => {
                                    // console.log('sparkles clciked ');
                                    setShowQuickInfo(!showQuickInfo);
                                }} />
                        </div>
                    ]}
                    globalFilterFields={['Account Id', 'Account Name']}
                    downloadOption={true}
                    pagination={true}
                    numberOfRows={20}
                    rowsPerPageOptions={[25, 50, 100]}                 >
                </Table>
            </div>
            {
                showQuickInfo && (
                    <div className=' w-1/5 p-4 bg-backgroundColor flex flex-col items-start' style={{ width: '20%', gap: '20px', borderRight: '2px' }}>
                        <p>Quick </p>
                        {console.log("One", Object.keys(averagePercentages))
                        }
                        {
                             console.log("Two", averagePercentages)
                        }
                        {Object.keys(averagePercentages).map(key => (
                            <>
                                {averagePercentages[key]?.total > 0 && (
                                    <div className={'flex items-center'} style={{ gap: '20px' }} key={key}>
                                        <div style={{ width: '100px' }}>
                                            <Gauge
                                                percentage={parseFloat(((averagePercentages[key]?.healthy / averagePercentages[key]?.total) * 100).toFixed(2)) > 100 || parseFloat(((averagePercentages[key]?.healthy / averagePercentages[key]?.total) * 100).toFixed(2)) < 0 ? 0 : parseFloat(((averagePercentages[key]?.healthy / averagePercentages[key]?.total) * 100).toFixed(2))} // Set percentage based on the average percentage for the key
                                                lableOn={false} // Assuming this is a prop for the Gauge component to toggle label visibility
                                            />
                                        </div>
                                        <div className=" text-xs font-medium flex flex-col">
                                            <p className=" text-primaryText font-bold">{key}  {averagePercentages[key]?.total > 0 ? parseFloat(((averagePercentages[key]?.healthy / averagePercentages[key]?.total) * 100).toFixed(2)) : 0}%</p>
                                            <p className={'text-gray-400'} >{averagePercentages[key]?.healthy}/{averagePercentages[key]?.total}</p>
                                            {/* <p className=" text-primaryText">{averagePercentages[key]?.healthy}/{averagePercentages[key]?.total} Healthy device for {averagePercentages[key]?.accountCount} accounts</p> */}
                                        </div>
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                )
            }
        </div >



        // <div className={tw`flex flex-col w-full h-[100vh]`}>
        //     <div className={tw`flex w-full h-full divide-x divide-dividerLines`}>
        //         <div className={tw`w-full md:w-4/5 lg:4/5 h-full flex flex-col justify-between bg-backgroundColor`}>
        //             <div>
        //                 <div className={tw`flex bg-[#EDFAF4] h-16 drop-shadow-md overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style]:none [scrollbar-width]:none`}>
        //                     <InsightText
        //                         primaryText={"91 King William Street-7th Floor"}
        //                         secondaryText={
        //                             <div className='flex flex-col text-xs'>
        //                                 <p>Australia-Adelaide</p>
        //                             </div>
        //                         }
        //                         contentInput={
        //                             <p className=" text-xs">25%</p>
        //                         }
        //                     />
        //                     <InsightText
        //                         primaryText={"91 King William Street-7th Floor"}
        //                         secondaryText={
        //                             <div className='flex flex-col text-xs'>
        //                                 <p>Australia-Adelaide</p>
        //                             </div>
        //                         }
        //                         contentInput={
        //                             <p className="text-xs">25%</p>
        //                         }
        //                     />
        //                     <InsightText
        //                         primaryText={"91 King William Street-7th Floor"}
        //                         secondaryText={
        //                             <div className='flex flex-col text-xs'>
        //                                 <p>Australia-Adelaide</p>
        //                             </div>
        //                         }
        //                         contentInput={
        //                             <p className=" text-xs">25%</p>
        //                         }
        //                     />
        //                     <InsightText
        //                         primaryText={"91 King William Street-7th Floor"}
        //                         secondaryText={
        //                             <div className='flex flex-col text-xs'>
        //                                 <p>Australia-Adelaide</p>
        //                             </div>
        //                         }
        //                         contentInput={
        //                             <p className=" text-xs">25%</p>
        //                         }
        //                     />
        //                 </div>
        //                 <Table
        //                     data={accountInfoData}
        //                     imageCol={['logoUrl']}
        //                     frozenCol={['logoUrl']}
        //                     dropdownFilter={[
        //                         {
        //                             key: 'accountId',
        //                             placeholder: 'Account Id',
        //                         },
        //                         {
        //                             key: 'accountName',
        //                             placeholder: 'Account Name',
        //                         },
        //                     ]}
        //                     globalFilterFields={['accountId', 'accountName']}
        //                     downloadOption={true}
        //                     numberOfRows={20}
        //                     rowsPerPageOptions={[25, 50, 100]}
        //                 >
        //                 </Table>
        //                 {/* <div className={tw`mt-4 h-[29rem]`}>
        //                     <div
        //                         className={tw`h-14 m-4 md:m-1 md:mx-3 lg:mx-3 
        //                             flex flex-col md:flex-row lg:flex-row 2xl:flex-row
        //                             justify-start items-start md:items-center lg:items-center gap-3`}
        //                     >
        //                         <div className={tw`w-full md:mb-0 lg:mb-0 md:w-52 lg:w-52 2xl:w-52`}>
        //                             <SearchBox
        //                                 placeHolder={'Search'}
        //                                 type={'text'}
        //                                 border={true}
        //                                 onChange={() => {

        //                                 }}
        //                             />
        //                         </div>
        //                         <div className='w-full flex justify-between items-center'>
        //                             {filters && (
        //                                 <>
        //                                     {filters.map((filter: any, index: number) => (
        //                                         <div key={index}>{filter}</div>
        //                                     ))}
        //                                 </>
        //                             )}
        //                         </div>
        //                     </div>
        //                     <Table
        //                         columns={selectedColumns}
        //                         stickyColumms={stickyColumms}
        //                         rows={rows}
        //                         filters={filters}
        //                         alternateRowColor={true}
        //                     />
        //                 </div> */}
        //             </div>
        //         </div>
        //         <div className={tw`hidden md:w-1/5 lg:1/5 md:block lg:block px-6 py-4 h-full bg-webBackgroundColor`}>
        //             <div className={tw`flex flex-col justify-start gap-8 `}>
        //                 <div className={tw`font-semibold text-sm text-primaryText`}>
        //                     <p>Quick Info</p>
        //                 </div>
        //                 {Object.keys(averagePercentages).map(key => (
        //                     <>
        //                         {averagePercentages[key]?.total > 0 && (
        //                             <div className={tw`flex gap-4 items-center`} key={key}>
        //                                 <div className={tw`w-20`}>
        //                                     <Gauge
        //                                         percentage={parseFloat(((averagePercentages[key]?.healthy / averagePercentages[key]?.total) * 100).toFixed(2))} // Set percentage based on the average percentage for the key
        //                                         lableOn={false} // Assuming this is a prop for the Gauge component to toggle label visibility
        //                                     />
        //                                 </div>
        //                                 <div className=" text-xs font-medium flex flex-col">
        //                                     <p className=" text-primaryText font-bold">{key}  {averagePercentages[key]?.total > 0 ? parseFloat(((averagePercentages[key]?.healthy / averagePercentages[key]?.total) * 100).toFixed(2)) : 0}%</p>
        //                                     <p className={tw`text-gray-400`} >{averagePercentages[key]?.healthy}/{averagePercentages[key]?.total}</p>
        //                                     {/* <p className=" text-primaryText">{averagePercentages[key]?.healthy}/{averagePercentages[key]?.total} Healthy device for {averagePercentages[key]?.accountCount} accounts</p> */}
        //                                 </div>
        //                             </div>
        //                         )}
        //                     </>
        //                 ))}
        //             </div>
        //         </div>
        //     </div>
        // </div >
    )
}

export default HealthOverview;